import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import DrillThroughFilterMenu from '../DrillThroughFilterMenu/DrillThroughFilterMenu';
import { setFilterPanel } from '../../store/redux/slices/filterPanelSlice';
import { useDispatch } from 'react-redux';

const Wrapper = styled.div`
  font-family: Open Sans;
  width: 80%;

  //change this to your own
  margin: 50px 0px 20px 0px;
  align-items: left;
`;

const BarsWrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 8% 80% 5%;
  gap: 5px;
  margin-left: 45px;
  padding-top: 5px;

  color: #636363;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
`;

const Bar = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`;

const FilledBar = styled.div`
  // flex: ${(props) => props.percentage};
  // height: 27px;
  background-color: ${(props) => props.barColor || '#EAAABD'};
  border-radius: ${(props) =>
    props.percentage === 100 ? '3px' : '3px 0 0 3px'};
  margin: 8px 0px 0px 0px;

  height: 32px;
  // background: rgb(218, 217, 219);
  // width: 0%;
  // min-width: 1%;
  // border-radius: 3px 0px 0px 3px;
`;

const GenderBasedRating = ({
  data,
  gender,
  handleTabClick,
  drillThroughType,
  showDrillThrough = true,
}) => {
  /* const minwidth = '1px'; */
  const getBarColor = () => {
    switch (gender) {
      case 'male':
        // return '#6640B8';
        return '#3D9FF8';
      case 'female':
        // return '#EAAABD';
        return '#FF9AB8';
      case 'unknown':
        // return '#D2D2D4';
        return 'rgba(218, 217, 219,  0.8)';
      default:
        return '#FF9AB8'; // Default color if gender is not recognized
    }
  };
  const [rightClickedBar, setRightClickedBar] = useState(null);
  const [showRightClickPopup, setShowRightClickPopup] = useState(false);
  const [rightClickPosition, setRightClickPosition] = useState({
    top: 0,
    left: 0,
  });
  const barContainerRef = useRef(null);
  const handleBarRightClick = (event, barData) => {
    event.preventDefault();

    if (barContainerRef.current) {
      const rect = barContainerRef.current.getBoundingClientRect();
      const top = event.clientY - rect.top;
      const left = event.clientX - rect.left;

      setRightClickPosition({ top, left });
    }

    setRightClickedBar({
      name: gender,
      value: barData,
    });
    setShowRightClickPopup(true);
  };
  const popupRef = useRef(null);
  const dispatch = useDispatch();
  const handleDrillThrough = (data) => {
    var filterPanel = {};
    filterPanel = {
      rating: [`${data?.value}`],
      gender: [data?.name?.toLowerCase()],
    };

    dispatch(setFilterPanel(filterPanel));
    setShowRightClickPopup(false);
    handleTabClick('commentsTab');
  };
  return (
    <Wrapper
      ref={barContainerRef}
      style={{
        position: 'relative',
      }}
    >
      {data?.rating.map((percentage, index) => (
        <BarsWrapper key={index}>
          <div style={{ lineHeight: '32px', margin: '8px 0px 0px 5px' }}>
            {5 - index} Star
          </div>
          <Bar>
            <FilledBar
              data-testid='filled-bar'
              percentage={percentage}
              style={{ width: `${percentage + 1}%` }}
              barColor={getBarColor()}
              onContextMenu={(e) => {
                if (showDrillThrough === true) {
                  handleBarRightClick(e, 5 - index);
                }
              }}
            ></FilledBar>
            <div
              style={{ lineHeight: '32px', margin: '8px 0px 0px 5px' }}
            >{`${percentage}%`}</div>
          </Bar>
          {/* <PercentageLabel>{`${percentage}%`}</PercentageLabel> */}
        </BarsWrapper>
      ))}
      {showRightClickPopup && rightClickedBar && (
        <div
          style={{
            position: 'absolute',
            top: `${rightClickPosition.top}px`,
            left: `${rightClickPosition.left}px`,
            zIndex: 9999,
            background: 'white',
            borderRadius: '6px',
          }}
          ref={popupRef}
        >
          <DrillThroughFilterMenu
            handleDrillThrough={() =>
              handleDrillThrough({
                name: rightClickedBar?.name,
                value: rightClickedBar?.value,
              })
            }
          />
        </div>
      )}
    </Wrapper>
  );
};

export default GenderBasedRating;
